<template>
  <div class="tenant-msg">
    <div class="tenant-box">
      <div class="user-box">
        <!-- class="surname" -->
        <div class="surname" :style="{ 'background-color': color16() }">
          {{ touristData.lesseeName ? touristData.lesseeName.substring(0, 1) : '' }}
        </div>
        <div class="name-box">
          <div class="user-msg">
            <h1>{{ touristData.lesseeName }}</h1>
          </div>
          <!-- 面积拼接 -->
          <p>{{ touristData.grossFloorArea }}</p>
          <p>{{ touristData.otherInfo }}</p>
        </div>
      </div>
      <div class="position-box">
        <h1>{{ touristData.brandName }}</h1>
        <h1>{{ touristData.shopNatureId | filterDict(shopsTypeList) }}</h1>
        <p>{{ touristData.businessDistrictName + touristData.streetName }}</p>
      </div>
      <div class="price-box">
        <h1 v-if="!iscontractYype">
          {{ touristData.requirementPriceStart | keepTwo }}-{{ touristData.requirementPriceEnd | keepTwo }}万元
        </h1>
        <h1 v-else>{{ touristData.rentExpenseStart }}-{{ touristData.rentExpenseEnd }}元/月</h1>

        <p v-if="touristData.investmentType">{{ touristData.investmentType | filterDict(investmentTypelist) }}</p>
        <p v-else>
          {{ (touristData.requirementAreaEnd / 30).toFixed(2) }}-{{
            (touristData.requirementAreaStart / 30).toFixed(2)
          }}m²
        </p>
      </div>
      <div class="position-box">
        <h1>
          {{
            touristData.followUpCreateTime ? $moment(touristData.followUpCreateTime).format('YYYY年MM月DD日') : '暂无'
          }}跟进
        </h1>
        <p>
          {{ touristData.takeLookCount ? touristData.takeLookCount : 0 }}次带看
          <span style="display: inline-block; padding-left: 10px">
            {{ touristData.inMoreCount ? touristData.inMoreCount : 0 }}次一带多看
          </span>
        </p>
      </div>
      <div class="position-box">
        <h1>{{ touristData.relatedPersonnelName }}</h1>
        <p>{{ touristData.relatedPersonnelCreateTime }}日录入</p>
      </div>
    </div>
    <p class="number">{{ touristData.lesseeCode }}</p>
  </div>
</template>

<script>
export default {
  props: {
    touristData: {
      type: Object,
      default: null
    },
    shopsTypeList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    },
    // investmentTypelist: {
    //   type: Array,
    //   require: true
    // },
    // iscontractYype: {
    //   type: Boolean,
    //   require: true
    // },
    investmentTypelist: {
      type: Array,
      default: () => {
        return []
      }
    },
    iscontractYype: {
      type: Boolean
    }
  },
  data () {
    return {
      // shopsTypeList: []
    }
  },
  methods: {
    // 十六进制颜色随机
    color16 () {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    }
  },
  beforeCreate () {},
  created () {}
}
</script>
<style lang="less" scoped>
.tenant-msg {
  margin: 0 20px;

  .tenant-box {
    display: flex;
    justify-content: space-between;
    .user-box {
      display: flex;
      align-items: center;
      .surname {
        width: 80px;
        height: 80px;
        background-color: #fbc8cb;
        text-align: center;
        line-height: 80px;
        font-size: 24px;
        color: #fff;
        border-radius: 10px;
        margin-right: 20px;
      }
      .name-box {
        height: 80px;
        box-sizing: border-box;
      }
      .user-msg {
        display: flex;
        align-items: center;
        h1 {
          font-size: 16px;
          font-weight: 700;
          margin-top: 8px;
        }
        span {
          padding: 0px 16px;
          border: 1px solid #f6bdbf;
          font-size: 12px;
          height: 20px;
          color: #f6bdbf;
          margin: 0 6px 2px 6px;
          display: inline-block;
          background-color: #feeeee;
          border-radius: 4px;
        }
      }
      p {
        padding-top: 10px;
        font-size: 14px;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0;
        white-space: nowrap;
        color: #000;
        width: 200px;
      }
    }
    .position-box {
      width: 180px;
      padding-top: 10px;
      // max-width: 160px;
      h1 {
        font-size: 14px;
        font-weight: 700;
      }
      P {
        font-size: 14px;
        padding-top: 14px;
      }
    }
    .price-box {
      width: 160px;
      padding-top: 10px;
      h1 {
        color: #ff7202;
        font-size: 14px;
        font-weight: 700;
      }
      p {
        color: #222222;
        padding-top: 14px;
      }
    }
  }
  .number {
    padding-top: 12px;
    font-size: 16px;
    color: #222222;
  }
}
</style>
